import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImpersonationRulesComponent } from './impersonation-rules/impersonation-rules.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { BBSFControlsModule } from 'bbsf-controls';
import { BlockUIModule } from 'ng-block-ui';
import { AuthModule } from '../core/auth.module';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatMenuModule } from '@angular/material/menu';
import { InlineSVGModule } from 'ng-inline-svg';
import { EmptyDataModule } from '../empty-data/empty-data.module';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bbsf-utilities';
import { ImpersonationRuleService } from '../shared/Services/ImpersonationRuleService.service';


@NgModule({
  declarations: [ImpersonationRulesComponent],
  imports: [
    
    RouterModule.forRoot([
      { path: 'ImpersonationRule',component:ImpersonationRulesComponent},
      { path: '', redirectTo: 'ImpersonationRule', pathMatch: 'full'},
    ]),
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    AuthModule,
    RouterModule,
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    BBSFControlsModule,
    NgbModule,
    MatMenuModule,
    InlineSVGModule,
    EmptyDataModule
  ],
  providers:[
    EnvironmentService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
    ImpersonationRuleService
  ]
})
export class ImpersonationRulesModule { }
